module.exports = __webpack_public_path__ + "static/media/R3.2bf11443.svg";